module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('p', {
    staticClass: "left"
  }, [_c('find-locale')], 1), _vm._v(" "), _c('p', {
    staticClass: "right",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('footer.byScriptist'))
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72444790!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 181
// module chunks = 2